import { Component, Input, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tgf-form-control-question-processor',
  templateUrl: './form-control-question-processor.component.html',
  styleUrls: ['./form-control-question-processor.component.scss']
})
export class FormControlQuestionProcessor {
  @Input() questionJson: any;
  @Input() form!: FormGroup;
  @Input() afterQuestionsTemplate?: TemplateRef<any>;

  @Input() questionsToSkip: Array<any> = [];
  @Input() questionsToInclude: Array<any> = [];
  @Input() parentModel!: any;

  mapQuestionModel(model: any) {
    if (this.questionJson.valueChangesFunctions &&
      this.questionJson.valueChangesFunctions[model.controlName]) {
      model.valueChangesFunction = this.questionJson.valueChangesFunctions[model.controlName];
    }

    return model;
  }

  shouldInclude(model: any) {
    return !model?.exclude &&
      (this.questionsToSkip?.length === 0 || !this.questionsToSkip.includes(model.name)) &&
      (this.questionsToInclude?.length === 0 || this.questionsToInclude.includes(model.name));
  }
}
